const config = {
  // * Local
  //  base_url: 'http://localhost:5000',
  // * Production
   base_url: 'https://code-challenge-proxy-server.herokuapp.com',
  count: 5,
  result_type: 'popular',
  tweet_mode: 'extended',
}

export default config